var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { getFontAwesomeIcon, hasValue, isFontawesomeIcon } from '@utils';
import { getInputSizeStyles, getInputStateClass } from './utils';
import { UXPContext } from "@core/context/Context";
import { FontAwesomeIconWrapper } from "@icon/fontawesome/FontAwesomeIconWrapper";
import { Dropdown } from '../../popups/Dropdown';
import classNames from 'classnames';
import DataList from '../../list/DataList';
import SearchBox from './SearchBox';
import Checkbox from './Checkbox';
import useToast from "@notifications/Toast/useToast";
import ButtonComponent from "@widget/buttons/ButtonComponent";
import DropdownIndicator from "@widget/other/DropdownIndicator";
const MultiSelectBase = (props) => {
    const context = React.useContext(UXPContext);
    const toast = useToast();
    // props
    let { selected, options, labelField, valueField, placeholder, className, isValid, onChange, showEndOfContent, iconField, renderOption, wrapSelectedItemsToOneLine, selectAllOnLoad, hideClearButton, hideDoneButton, dropdownClassname, dropdownMinHeight, dropdownMinWidth, dropdownMaxWidth, minWidth, maxWidth, width, fullWidth, disabled, readOnly, renderCustomDropdownContent, renderPlaceholder, pageSize, selectedLabels, position, } = props;
    // states
    const [showPicker, setShowPicker] = React.useState(false);
    const [selectedOptions, setSelectedOptions] = React.useState([]);
    const [query, setQuery] = React.useState("");
    const [selIndex, setSelIndex] = React.useState(-1);
    const [filteredOptions, setFilteredOptions] = React.useState([]);
    const [loadingSelectedOptions, setLoadingSelectedOptions] = React.useState(false);
    const [isFocused, setIsFocused] = React.useState(false);
    const optionContainerRef = React.useRef(null);
    const triggerRef = React.useRef(null);
    const hasIcon = (!!iconField && (iconField === null || iconField === void 0 ? void 0 : iconField.trim().length) > 0);
    if (!hasValue(placeholder))
        placeholder = context.$L('uxp-core.text.select-an-item');
    const isDynamicLoading = typeof options === 'function';
    const selectAllOption = { [labelField]: 'Select All', [valueField]: '__select_all__' };
    // Reset filtered options when dropdown opens
    React.useEffect(() => {
        if (showPicker && !isDynamicLoading) {
            let opts = Array.isArray(options) ? [...options] : [];
            opts.unshift(selectAllOption);
            setFilteredOptions(opts);
            setQuery("");
        }
    }, [showPicker, options, isDynamicLoading]);
    React.useEffect(() => {
        if (Array.isArray(options)) {
            let opts = [...options];
            opts.unshift(selectAllOption);
            setFilteredOptions(opts);
        }
    }, [options]);
    React.useEffect(() => {
        updateSelectedOptions();
    }, [selected, filteredOptions, selectedLabels]);
    // scroll the highlighted option into view on keyboard navigation
    React.useEffect(() => {
        if (selIndex < 0)
            return;
        let options = getOptions();
        let selOpt = options[selIndex];
        if (selOpt) {
            selOpt.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest',
            });
        }
    }, [selIndex]);
    function updateSelectedOptions() {
        return __awaiter(this, void 0, void 0, function* () {
            // debugger
            setLoadingSelectedOptions(true);
            let selOpts = [];
            if (selected && selected.length > 0) {
                if (Array.isArray(options)) {
                    selOpts = options.filter((option) => (!!option && selected.indexOf(option[valueField]) !== -1));
                }
                else if (!!selectedLabels) {
                    if (Array.isArray(selectedLabels)) {
                        selOpts = selected.map((val, index) => ({
                            [labelField]: selectedLabels[index] || val,
                            [valueField]: val
                        }));
                    }
                    else if (typeof selectedLabels === 'function') {
                        try {
                            const opts = yield selectedLabels(selected);
                            if (Array.isArray(opts) && opts.length > 0) {
                                selOpts = opts;
                            }
                        }
                        catch (e) {
                            console.error('Unable to get the selected options details. error:', e);
                        }
                    }
                }
            }
            setSelectedOptions(selOpts);
            setLoadingSelectedOptions(false);
        });
    }
    function removeSelectAll(options) {
        return options.filter(o => (!!o && o[valueField] !== '__select_all__'));
    }
    // filter out option dom nodes as html elements
    const getOptions = () => {
        let container = optionContainerRef.current;
        let options = [];
        if (container) {
            options = Array.from(container === null || container === void 0 ? void 0 : container.querySelectorAll(".uxpcore_select__option"));
        }
        return options;
    };
    // handle backdrop ref
    const closePicker = () => {
        setQuery("");
        setSelIndex(-1);
        setShowPicker(false);
        setTimeout(() => { var _a; return (_a = triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 100);
    };
    // Handle focus to show focus styles
    const handleFocus = () => {
        if (!disabled && !readOnly) {
            setIsFocused(true);
        }
    };
    // Handle blur to remove focus styles
    const handleBlur = () => {
        if (!disabled && !readOnly) {
            setIsFocused(false);
        }
    };
    // Dropdown indicator icon - chevron up/down
    const dropdownIndicator = _jsx(DropdownIndicator, { isOpen: showPicker });
    //handle select 
    const handleSelect = (option) => {
        // Handle Select All option
        if (option[valueField] === '__select_all__') {
            handleSelectAll();
            return;
        }
        let val = option[valueField];
        let opt = selectedOptions.find((o) => !!o && o[valueField] === val);
        let _selectedOpts = [...selectedOptions];
        if (opt) {
            // remove from selected 
            _selectedOpts = _selectedOpts.filter((opt) => (!!opt && opt[valueField] !== val));
        }
        else {
            // add to selected 
            _selectedOpts.push(option);
        }
        let values = _selectedOpts.map(x => x[valueField]);
        onChange(values, _selectedOpts);
    };
    // handle input change
    const handleInputChange = (val) => {
        setQuery(val);
        setSelIndex(-1);
        if (!isDynamicLoading) {
            let regEx = new RegExp(val, 'i');
            let _options = Array.isArray(options)
                ? [selectAllOption, ...options.filter((opt) => { var _a, _b; return regEx.test(((_b = (_a = opt[labelField]) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a)) || ''); })]
                : [selectAllOption];
            setFilteredOptions(_options);
        }
    };
    // handle keyboard inputs
    const handleKeyboardInputs = (e) => {
        if (e.key === "ArrowDown") {
            e.preventDefault();
            const len = isDynamicLoading ? getOptions().length : filteredOptions.length;
            if (len === 0)
                return;
            setSelIndex(prev => (prev + 1 < len ? prev + 1 : 0));
        }
        if (e.key === "ArrowUp") {
            e.preventDefault();
            const len = isDynamicLoading ? getOptions().length : filteredOptions.length;
            if (len === 0)
                return;
            setSelIndex(prev => (prev <= 0 ? len - 1 : prev - 1));
        }
        // discard on esc
        if (e.key === "Escape") {
            closePicker();
            setQuery("");
        }
        // change on enter — data-driven for static, DOM fallback for dynamic
        if (e.key === "Enter") {
            if (selIndex >= 0) {
                if (!isDynamicLoading) {
                    const item = filteredOptions[selIndex];
                    if (item)
                        handleSelect(item);
                }
                else {
                    const domOptions = getOptions();
                    const selOpt = domOptions[selIndex];
                    if (selOpt) {
                        const item = JSON.parse(selOpt.dataset.value);
                        handleSelect(item);
                    }
                }
            }
        }
    };
    function hasSelected() {
        return selectedOptions && selectedOptions.length > 0;
    }
    function handleSelectedOptionClick(e, option) {
        e.preventDefault();
        e.stopPropagation();
        handleSelect(option);
    }
    function getIcon(opt) {
        if (!opt)
            return null;
        if (!opt[iconField] || opt[iconField].trim().length === 0)
            return null;
        let icon = null;
        if (isFontawesomeIcon(opt[iconField])) {
            const parts = getFontAwesomeIcon(opt[iconField]);
            icon = _jsx("div", { className: "fa-icon", children: _jsx(FontAwesomeIconWrapper, { icon: parts }) });
        }
        else {
            icon = _jsx("div", { className: "image-icon", children: _jsx("div", { className: "icon", style: {
                        backgroundImage: `url(${opt[iconField]})`
                    } }) });
        }
        return icon;
    }
    function hasAllSelected() {
        if (!Array.isArray(options) || options.length === 0)
            return false;
        const nonSelectAllOptions = Array.isArray(options) ? options : [];
        return (selected === null || selected === void 0 ? void 0 : selected.length) === nonSelectAllOptions.length;
    }
    function handleSelectAll() {
        if (hasAllSelected()) {
            clearSelected();
        }
        else {
            const allOptions = Array.isArray(options) ? options : [];
            onChange(allOptions.map(op => op[valueField]), allOptions);
        }
    }
    function clearSelected() {
        onChange([], []);
    }
    const loadPaginatedData = React.useCallback((max, lastToken, args) => __awaiter(void 0, void 0, void 0, function* () {
        return options(max, lastToken, args);
    }), [options]);
    const memorizedArgs = React.useMemo(() => {
        return hasValue(query) ? { query } : {};
    }, [query]);
    const pillStyles = {};
    if (!!(renderPlaceholder === null || renderPlaceholder === void 0 ? void 0 : renderPlaceholder.renderAsPill)) {
        pillStyles.width = 'auto';
        pillStyles.display = 'inline-block';
        const { minWidth, maxWidth } = renderPlaceholder.renderAsPill;
        if (hasValue(minWidth))
            pillStyles.minWidth = minWidth + 'px';
        if (hasValue(maxWidth))
            pillStyles.maxWidth = maxWidth + 'px';
    }
    const handleKeyDownOnTrigger = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setShowPicker(true);
        }
    };
    const renderDropdownContent = () => (_jsx("div", { onKeyDown: !renderCustomDropdownContent ? handleKeyboardInputs : undefined, children: !!renderCustomDropdownContent
            ? _jsx(_Fragment, { children: renderCustomDropdownContent(() => { setShowPicker(false); }) })
            : _jsxs(_Fragment, { children: [_jsx(SearchBox, { value: query, onChange: handleInputChange, placeholder: "", autoFocus: true, className: "uxpcore_select__search" }), _jsx("div", { className: "uxpcore_select__dropdown-list", ref: optionContainerRef, children: _jsx(DataList, { data: isDynamicLoading ? loadPaginatedData : filteredOptions, pageSize: pageSize || 6, renderItem: (opt, key) => {
                                if ((opt === null || opt === void 0 ? void 0 : opt[valueField]) === '__select_all__') {
                                    return _jsx("div", { className: classNames("uxpcore_select__option", "uxpcore_select__option--select-all", {
                                            "uxpcore_select__option--highlighted": key === selIndex
                                        }), onClick: (e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleSelectAll();
                                        }, "data-value": JSON.stringify(opt), onMouseOver: () => setSelIndex(key), children: _jsx("div", { className: "uxpcore_select__option-content", children: _jsx(Checkbox, { checked: hasAllSelected(), onChange: () => { }, label: 'Select All' }) }) }, key);
                                }
                                let isSelected = selectedOptions.find((selectedOption) => (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[valueField]) === (opt === null || opt === void 0 ? void 0 : opt[valueField]));
                                let icon = getIcon(opt);
                                return _jsx("div", { className: classNames("uxpcore_select__option", {
                                        "uxpcore_select__option--selected": isSelected,
                                        "uxpcore_select__option--highlighted": key === selIndex
                                    }), onClick: () => handleSelect(opt), onMouseOver: () => setSelIndex(key), "data-value": JSON.stringify(opt), children: renderOption
                                        ? renderOption(opt, key, key === selIndex, !!isSelected)
                                        : _jsxs("div", { className: classNames("uxpcore_select__option-content", {
                                                'uxpcore_select__option-content--has-icon': hasIcon && !!icon
                                            }), children: [_jsx(Checkbox, { checked: isSelected ? true : false, onChange: () => { } }), hasIcon && _jsxs("div", { className: "uxpcore_select__option-icon", children: [" ", icon, " "] }), _jsx("div", { className: "uxpcore_select__option-label", children: opt === null || opt === void 0 ? void 0 : opt[labelField] })] }) }, key);
                            }, showFooter: false, showEndOfContent: showEndOfContent, renderNoItems: () => _jsx("div", { children: "No matching items" }), args: memorizedArgs }) }), (!hideClearButton || !hideDoneButton) &&
                        _jsxs("div", { className: "uxpcore_select__dropdown-footer", children: [!hideClearButton &&
                                    _jsx(ButtonComponent, { title: context.$L('uxp-core.text.clear'), onClick: clearSelected, variant: 'secondary', size: 'smaller' }), !hideDoneButton &&
                                    _jsx(ButtonComponent, { title: context.$L('uxp-core.text.done'), onClick: closePicker, size: 'smaller' })] })] }) }));
    function renderLabel() {
        if (!!(renderPlaceholder === null || renderPlaceholder === void 0 ? void 0 : renderPlaceholder.renderCustomPill)) {
            return renderPlaceholder === null || renderPlaceholder === void 0 ? void 0 : renderPlaceholder.renderCustomPill(handleSelectedOptionClick);
        }
        else {
            return (_jsx("div", { className: classNames("selected", { 'wrapped': wrapSelectedItemsToOneLine }), children: loadingSelectedOptions ?
                    _jsx(FontAwesomeIconWrapper, { icon: ['fas', 'spinner'], spin: true }) :
                    hasSelected() ?
                        _jsx(_Fragment, { children: selectedOptions.map((opt, key) => {
                                return _jsxs("div", { className: "sel-opt", style: pillStyles, children: [_jsx("div", { className: "text", children: (opt === null || opt === void 0 ? void 0 : opt[labelField]) || '' }), _jsx("div", { className: "close", onClick: e => handleSelectedOptionClick(e, opt), children: _jsx(FontAwesomeIconWrapper, { icon: ['fas', 'times'] }) })] }, key);
                            }) }) :
                        placeholder && _jsx("span", { children: placeholder }) }));
        }
    }
    const containerStyles = getInputSizeStyles({ minWidth, maxWidth, width, fullWidth, style: undefined });
    const handleTriggerClick = () => {
        if (!disabled && !readOnly) {
            setShowPicker(!showPicker);
        }
    };
    return (_jsxs("div", { className: classNames("uxpcore_multiselect", className), style: Object.assign(Object.assign({}, pillStyles), containerStyles), children: [!!(renderPlaceholder === null || renderPlaceholder === void 0 ? void 0 : renderPlaceholder.renderCustomPill) ? (_jsx("div", { ref: triggerRef, className: "uxpcore_multiselect__custom-trigger", onClick: handleTriggerClick, onKeyDown: handleKeyDownOnTrigger, onFocus: handleFocus, onBlur: handleBlur, tabIndex: disabled || readOnly ? -1 : 0, children: renderPlaceholder.renderCustomPill(handleSelectedOptionClick) })) : (
            /* Standard trigger */
            _jsxs("div", { ref: triggerRef, className: classNames("uxpcore_input", "uxpcore_input--multiselect", getInputStateClass({ disabled, readOnly, isValid }), {
                    "uxpcore_input--has-content": hasSelected(),
                    "uxpcore_input--has-suffix": true,
                    "uxpcore_input--focus": isFocused || showPicker,
                    "uxpcore_input--full-width": fullWidth
                }), onClick: handleTriggerClick, onKeyDown: handleKeyDownOnTrigger, onFocus: handleFocus, onBlur: handleBlur, tabIndex: disabled || readOnly ? -1 : 0, style: getInputSizeStyles({ minWidth, maxWidth, width, fullWidth, style: undefined }), children: [_jsx("div", { className: "uxpcore_input__value-multi", children: renderLabel() }), _jsx("div", { className: "uxpcore_input__suffix", children: dropdownIndicator })] })), _jsx(Dropdown, { externalTriggerRef: triggerRef, content: renderDropdownContent(), position: position || 'bottom-left', isOpen: showPicker, onToggle: closePicker, contentClassName: classNames("uxpcore_select__dropdown", "uxpcore_select__dropdown--multi", dropdownClassname), matchTriggerWidth: true, minWidth: dropdownMinWidth, maxWidth: dropdownMaxWidth || (hasValue(dropdownMinWidth) ? dropdownMinWidth : "20rem") })] }));
};
MultiSelectBase.defaultProps = {
    labelField: "label",
    valueField: "value",
    showEndOfContent: false
};
/**
 *
 * A select control to select multiple items from a list of items
 * @export
 *
 *  @example
 * ```
 *  // options
 *  let [selectedOptions, setSelectedOptions] = React.useState<string[]>([])
 *  let options = [
 *      {label: "Sri Lanka", value: "SL"},
 *      {label: "India", value: "IN"},
 *      {label: "United State", value: "US"},
 *  ]
 *
 *  <MultiSelect
 *      options={options}
 *      selected={selectedOptions}
 *      onChange={(newValues, options) => {
 *          setSelectedOptions(values)
 *      }}
 *  />
 * ```
 *
 * @example
 * ```
 *  // options
 *  let [selectedOptions, setSelectedOptions] = React.useState<string[]>([])
 *  let options = [
 *      {name: "Sri Lanka", code: "SL"},
 *      {name: "India", code: "IN"},
 *      {name: "United State", code: "US"},
 *  ]
 *
 *  <MultiSelect
 *      options={options}
 *      labelField="name"
 *      valueField="code"
 *      selected={selectedOptions}
 *      onChange={(newValues, options) => {
 *          setSelectedOptions(values)
 *      }}
 *  />
 * ```
 *
 */
const MultiSelect = React.memo((props) => {
    return _jsx(MultiSelectBase, Object.assign({}, props));
});
export default React.memo(MultiSelect);
